import { render, staticRenderFns } from "./BA_Clients.vue?vue&type=template&id=78cc649a&"
import script from "./BA_Clients.vue?vue&type=script&lang=js&"
export * from "./BA_Clients.vue?vue&type=script&lang=js&"
import style0 from "./BA_Clients.vue?vue&type=style&index=0&id=78cc649a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports